import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import useV2s from "hooks/useV2s";
import useTokenIdParam from "hooks/useTokenIdParam";

type V2ExistsGuardProps = {
  yeyElement: JSX.Element;
  neyElement: JSX.Element;
};

const V2ExistsGuard = ({ yeyElement, neyElement }: V2ExistsGuardProps) => {
  const tokenId = useTokenIdParam();
  const { allV2Ids } = useV2s();

  if (!allV2Ids) {
    return (
      <Center h="100vh">
        <BoldSpinner size="xl" />
      </Center>
    );
  }

  return tokenId !== undefined && allV2Ids.includes(tokenId)
    ? yeyElement
    : neyElement;
};

export default V2ExistsGuard;
